var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineEssentination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1243 7.50033C11.1243 7.15515 10.8445 6.87533 10.4993 6.87533C10.1542 6.87533 9.87435 7.15515 9.87435 7.50033L9.87435 9.37535H7.99935C7.65417 9.37535 7.37435 9.65517 7.37435 10.0003C7.37435 10.3455 7.65417 10.6253 7.99935 10.6253H9.87435V12.5003C9.87435 12.8455 10.1542 13.1253 10.4993 13.1253C10.8445 13.1253 11.1243 12.8455 11.1243 12.5003L11.1243 10.6253H12.9993C13.3445 10.6253 13.6243 10.3455 13.6243 10.0003C13.6243 9.65517 13.3445 9.37535 12.9993 9.37535H11.1243V7.50033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4993 1.04199C5.5518 1.04199 1.54102 5.05277 1.54102 10.0003C1.54102 14.9479 5.5518 18.9587 10.4993 18.9587C15.4469 18.9587 19.4577 14.9479 19.4577 10.0003C19.4577 5.05277 15.4469 1.04199 10.4993 1.04199ZM2.79102 10.0003C2.79102 5.74313 6.24215 2.29199 10.4993 2.29199C14.7565 2.29199 18.2077 5.74313 18.2077 10.0003C18.2077 14.2575 14.7565 17.7087 10.4993 17.7087C6.24215 17.7087 2.79102 14.2575 2.79102 10.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineEssentination);
export default __webpack_public_path__ + "static/media/OutlineEssentination.d3a70e6a6458330a220a7ad1eb21643f.svg";
export { ForwardRef as ReactComponent };